import { put, takeEvery } from 'redux-saga/effects';
import { FORM_ERROR } from 'final-form';
import { safeResolveAsync } from '../../utils';

import * as api from './api';
import { actions, types } from './duck';

// helpers to be tolerant to different BE payloads (no optional chaining)
const pickText = payload => {
  if (!payload || typeof payload !== 'object') return '';

  if (typeof payload.generated_text === 'string') return payload.generated_text;
  if (typeof payload.text === 'string') return payload.text;
  if (typeof payload.output === 'string') return payload.output;
  if (typeof payload.result === 'string') return payload.result;
  if (typeof payload.message === 'string') return payload.message;

  if (
    payload.choices &&
    Array.isArray(payload.choices) &&
    payload.choices.length > 0
  ) {
    const c0 = payload.choices[0];
    if (
      c0 &&
      c0.message &&
      typeof c0.message === 'object' &&
      typeof c0.message.content === 'string'
    ) {
      return c0.message.content;
    }
    if (c0 && typeof c0.text === 'string') return c0.text;
  }

  return '';
};

const pickImageDataUrl = payload => {
  if (!payload || typeof payload !== 'object') return null;

  const data = payload.data;
  const first = Array.isArray(data) && data.length > 0 ? data[0] : null;

  if (first && typeof first.url === 'string') return first.url;

  const b64 = first && (first.b64_json || first.b64);
  if (typeof b64 === 'string' && b64.length > 0) {
    return 'data:image/png;base64,' + b64;
  }

  return null;
};

export function* generateText({ id, params, resolve }) {
  try {
    yield put(actions.generateTextRequest(id));
    const res = yield api.generateText(params);

    if (res && res.status >= 200 && res.status < 300) {
      const text = pickText(res.data);
      yield put(actions.generateTextSuccess(id, { text }));
      yield safeResolveAsync(resolve, { text });
    } else {
      const error = (res && res.data) || 'Failed to generate text';
      yield put(actions.generateTextFailure(id, error));
      yield safeResolveAsync(resolve, { [FORM_ERROR]: error });
    }
  } catch (error) {
    const msg = (error && error.message) || 'Failed to generate text';
    yield put(actions.generateTextFailure(id, msg));
    yield safeResolveAsync(resolve, { [FORM_ERROR]: msg });
  }
}

export function* generateImage({ id, params, resolve }) {
  try {
    yield put(actions.generateImageRequest(id));
    const res = yield api.generateImage(params);

    if (res && res.status >= 200 && res.status < 300) {
      const dataUrl = pickImageDataUrl(res.data);
      if (!dataUrl) throw new Error('No image data returned');
      yield put(actions.generateImageSuccess(id, { dataUrl }));
      yield safeResolveAsync(resolve, { dataUrl });
    } else {
      const error = (res && res.data) || 'Failed to generate image';
      yield put(actions.generateImageFailure(id, error));
      yield safeResolveAsync(resolve, { [FORM_ERROR]: error });
    }
  } catch (error) {
    const msg = (error && error.message) || 'Failed to generate image';
    yield put(actions.generateImageFailure(id, msg));
    yield safeResolveAsync(resolve, { [FORM_ERROR]: msg });
  }
}

export default function* saga() {
  yield takeEvery(types.GENERATE_TEXT, generateText);
  yield takeEvery(types.GENERATE_IMAGE, generateImage);
}
